import request from './request';

/**
 * 认证相关API
 */

/**
 * 用户登录
 * @param {string} username - 用户名
 * @param {string} password - 密码
 * @returns {Promise} 登录结果，包含token和用户信息
 */
export function login(username, password) {
  return request({
    url: '/auth/login',
    method: 'post',
    data: {
      username,
      password
    }
  });
}

/**
 * 刷新Token
 * @param {string} refreshToken - 刷新Token
 * @returns {Promise} 新的访问Token
 */
export function refreshToken(refreshToken) {
  return request({
    url: '/auth/refresh',
    method: 'post',
    data: {
      refreshToken
    }
  });
}

/**
 * 验证Token
 * @returns {Promise} Token验证结果
 */
export function verifyToken() {
  return request({
    url: '/auth/verify',
    method: 'get'
  });
}

/**
 * 用户登出
 * @returns {Promise} 登出结果
 */
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  });
}
